#import "../fragments/assigned-user-fragment.graphql"

query GetUsersForManagedMeetings($first: Int, $after: String) {
    users(first: $first, after: $after) {
        pageInfo {
            __typename
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...AssignedUserFragment
            }
        }
    }
}
